export const inputsMapping = {
  text: 'Inputs.BasicInput',
  number: 'Inputs.BasicInput',
  date: 'Inputs.DateInput',
  startdate: 'Inputs.DateInput',
  phone: 'Inputs.BasicInput',
  radio: 'Inputs.RadioGroup',
  radio_price: 'ExtraOptionsRadio',
  iban: 'IbanInput',
  single_checkbox: 'CheckboxWrapper',
  checkbox_group: 'ExtraOptionsCheckbox',
  tel: 'Inputs.DateInput',
  select: 'Inputs.Select',
  select_price: 'ExtraOptionsSelect',
  meldcode: 'MeldCodeInput',
  textarea: 'Inputs.Textarea',
  EnergySwitchWarningCheckbox: 'EnergySwitchWarningCheckbox',
};

export const inputsAdditionalProps = {
  date: { iconProps: { name: '' } },
};

export default inputsMapping;
